<template>
  <div class="orderview">
    <!--订单查看  第一模块-->
    <div class="orderview-first">
      <div class="orderview-display-left">
        <div class="orderview-mergeId">
          <div class="orderview-first-div0">
            <div class="orderview-first-div0-title">用户ID</div>
            <el-input
              v-model="userId"
              placeholder="请输入用户ID"
              clearable
            ></el-input>
          </div>

          <div class="orderview-first-div0">
            <div class="orderview-first-div0-title">用户手机号</div>
            <el-input
              v-model="userPhone"
              placeholder="请输入手机号"
              clearable
            ></el-input>
          </div>

          <div class="orderview-first-div0">
            <div class="orderview-first-div0-title">订单号</div>
            <el-input
              v-model="userOrder"
              placeholder="请输入订单号"
              clearable
            ></el-input>
          </div>

          <div class="orderview-first-div0">
            <div class="orderview-first-div0-title">订单状态</div>
            <el-select
              v-model="selectorValue"
              placeholder="全部订单状态"
              clearable
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>

          <div class="orderview-first-div0">
            <div class="orderview-first-div0-title">用户付款时间</div>
            <el-date-picker
              v-model="paymentValue"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </div>
      </div>

      <div class="orderview-display-right">
        <div class="orderview-display-right-queer">
          <div class="orderview-first-div1">
            <div class="orderview-first-title">确认收货时间</div>
            <el-date-picker
              v-model="deliveryValue"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="orderview-display-right-dextro">
          <div class="orderview-first-div4">
            <div class="orderview-first-right">
              <div class="orderview-first-right-inquire" @click="inquireBtn">
                查询
              </div>
              <!-- <div class="orderview-first-right-derive" @click="export2Excel">
                导出订单
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--订单查看 第二模块  表格列表-->
    <div class="orderview-table">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          background: '#FAFAFA',
        }"
      >
        <el-table-column prop="uid" label="用户id" align="center" width="120">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="用户手机号"
          align="center"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="ordernum"
          label="订单号"
          align="center"
          width="200"
        >
        </el-table-column>

        <el-table-column label="商品信息" align="left" width="280">
          <template slot-scope="scope">
            <div class="commodity-div">
              <img class="commodity-div-left" :src="scope.row.image" />
              <div class="commodity-div-right">
                <div class="commodity-div-right-title">
                  {{ scope.row.name }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="goods_spec_name"
          label="规格"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <div class="scope-name">
              {{ scope.row.goods_spec_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="num" label="数量" align="center">
        </el-table-column>
        <el-table-column prop="is_shouhou" label="售后状态" align="center">
          <template slot-scope="scope">
            <div
              class="isShow-div"
              :style="{
                color:
                  scope.row.is_shouhou == 1
                    ? '#FF4133'
                    : scope.row.is_shouhou == 3
                    ? '#F9B63C'
                    : '#555555',
              }"
            >
              {{
                scope.row.is_shouhou == 0
                  ? '未售后'
                  : scope.row.is_shouhou == 1
                  ? '售后中'
                  : scope.row.is_shouhou == 2
                  ? '已售后'
                  : scope.row.is_shouhou == 3
                  ? '已拒绝'
                  : ''
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="单价" align="center">
          <template slot-scope="scope"> ￥{{ scope.row.price }} </template>
        </el-table-column>
        <el-table-column prop="totalPrice" label="总价" align="center">
          <template slot-scope="scope"> ￥{{ scope.row.totalPrice }} </template>
        </el-table-column>
        <el-table-column
          prop="paytime"
          label="用户付款时间"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.paytime }}
          </template>
        </el-table-column>
        <el-table-column
          prop="shouhuotime"
          label="用户确认收货时间"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.shouhuotime }}
          </template>
        </el-table-column>
        <el-table-column prop="getPrice" label="可获取利润" align="center">
          <template slot-scope="scope"> ￥{{ scope.row.getPrice }} </template>
        </el-table-column>
        <el-table-column prop="status" label="利润状态" align="center">
          <template slot-scope="scope">
            <div
              class="profitStatus-div"
              :style="{
                color: scope.row.status == 'ENTER' ? '#f9b63c' : '#666666',
              }"
            >
              {{
                scope.row.status == 'ENTER'
                  ? '已获取'
                  : scope.row.status == 'WAIT'
                  ? '锁定中'
                  : scope.row.status == 'PAST'
                  ? ''
                  : ''
              }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--订单查看 第三模块  分页列表 -->
    <div class="orderview-paging" v-if="orderTotal > 10">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="10"
        layout="prev, pager, next, sizes, jumper"
        :total="orderTotal"
        :pager-count="11"
      >
      </el-pagination>
    </div>
  </div>
</template>


<script>
import { getorderDetail, orderDetail } from '../../api/partenr' // 订单列表数据、订单详情数据
import { formatDate } from '../../utils/date'
import Bus from '../../utils/bus'
export default {
  filters: {
    formatDate(time) {
      time = time * 1000 //注意：time应为格式为13位unix时间戳，如果是10位的unix时间戳，需要乘以1000
      let date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    },
  },
  data() {
    return {
      // 用户id
      userId: '',
      userIds: '',
      // 手机号
      userPhone: '',
      // 订单号
      userOrder: '',
      // 表格内容
      tableData: [],
      // 用户付款时间输入框
      paymentValue: [],
      // 用户清空付款时间输入框的时候起始值
      paymentStatusA: '',
      // 用户清空付款时间输入框的时候结尾值
      paymentStatusB: '',
      // 用户确认收货时间
      deliveryValue: [],
      // 用户确认收货时间起始值
      deliveryStatusA: '',
      // 用户确认收货时间结尾值
      deliveryStatusB: '',
      // 时间区间
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      // 全部订单状态
      options: [
        {
          value: '2',
          label: '待发货',
        },
        {
          value: '3',
          label: '待收货',
        },
        {
          value: '5',
          label: '已完成',
        },
        {
          value: '6',
          label: '售后中',
        },
        {
          value: '9',
          label: '已售后',
        },
      ],
      // 全部订单状态选择对应值
      selectorValue: '',
      // 用户点击详情后页面切换
      orderShow: false,
      // 页码
      page: 1,
      // 页数
      limit: 10,
      //  订单列表总数
      orderTotal: 0,

      // -------------------------------对应的订单详情内部变量存放地址------------------------------
      orderDetailsObj: {}, // 订单详情数据存放对象
    }
  },
  created() {
    this.userIds = this.$route.query.userId

    // // 订单列表数据
    this.orderList()
  },
  updated() {
    if (this.$route.query.userId == undefined) {
      Bus.$emit('detele', 'partenrIncomeOrder')
    }
  },
  methods: {
    // 用户点击查询
    inquireBtn() {
      if (this.paymentValue != null) {
        this.paymentStatusA = this.paymentValue[0]
        this.paymentStatusB = this.paymentValue[1]
      } else {
        this.paymentStatusA = ''
        this.paymentStatusB = ''
      }

      if (this.deliveryValue != null) {
        this.deliveryStatusA = this.deliveryValue[0]
        this.deliveryStatusB = this.deliveryValue[1]
      } else {
        this.deliveryStatusA = ''
        this.deliveryStatusB = ''
      }

      this.orderList()
    },
    // // 用户点击对应的查看详情
    // particularsBtn(row) {
    //     // 点击对应的查看按钮进入对应的顶大详情
    //     this.orderDetails(row)
    // },
    // 用户点击导出订单
    // export2Excel() {
    //   require.ensure([], () => {
    //     const { export_json_to_excel } = require('../../excel/Export2Excel')

    //     let params = {
    //       excel: 1, // 导出订单
    //       uid: this.userId, // 用户id
    //       phone: this.userPhone, // 用户手机号
    //       payStartTime: this.paymentStatusA, // 付款开始时间 Y-M-D H:I:S
    //       payEndTime: this.paymentStatusB, // 付款结束时间 Y-M-D H:I:S
    //       ordernum: this.userOrder, // 订单号
    //       status: this.selectorValue, // 支付状态:0=已取消,1=待支付,2=已支付,3=已发货,4=待评价,5=已完成，6=售后中,9=已删除
    //       shouhuoStartTime: this.deliveryStatusA, // 确认收货开始时间
    //       shouhuoEndTime: this.deliveryStatusB, // 确认收货结束时间
    //       pageSize: this.limit, // 页码
    //       page: this.page, // 页数
    //     }

    //     orderDetail(params).then((res) => {
    //       console.log('点击导出订单', res)
    //       const tHeader = [
    //         '用户id',
    //         '用户手机号',
    //         '订单号',
    //         '订单实付总价',
    //         '订单状态',
    //         '用户付款时间',
    //         '用户确认收货时间',
    //         '可获取利润',
    //         '利润状态',
    //       ]
    //       // 上面设置Excel的表格第一行的标题
    //       const filterVal = [
    //         'uid',
    //         'phone',
    //         'ordernum',
    //         'allprice',
    //         'status',
    //         'paytime',
    //         'shouhuotime',
    //         'getPrice',
    //         'priceStatus',
    //       ]

    //       res.data.content.forEach((item, index) => {
    //         ;(item.status =
    //           item.status == 2
    //             ? '待发货'
    //             : item.status == 3
    //             ? '待收货'
    //             : item.status == 5
    //             ? '已完成'
    //             : item.status == 6
    //             ? '售后中'
    //             : ''),
    //           (item.paytime = this.formatDate(item.paytime)),
    //           (item.shouhuotime =
    //             item.shouhuotime != ''
    //               ? this.formatDate(item.shouhuotime)
    //               : ''),
    //           (item.priceStatus =
    //             item.priceStatus == 'ENTER'
    //               ? '已获取'
    //               : item.priceStatus == 'WAIT'
    //               ? '锁定中'
    //               : item.priceStatus == 'PAST'
    //               ? ''
    //               : '')
    //       })

    //       console.log('打印', res.data.content)

    //       const list = res.data.content //把data里的tableData存到list
    //       const data = this.formatJson(filterVal, list)
    //       export_json_to_excel(tHeader, data, '订单查看excel')
    //     })
    //   })
    // },
    // exccel导出表格
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]))
    },
    // 时间转化
    formatDate(time) {
      time = time * 1000 //注意：time应为格式为13位unix时间戳，如果是10位的unix时间戳，需要乘以1000
      let date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    },

    // 获取订单列表数据
    orderList() {
      let params = {
        userId: this.userIds,
        uid: this.userId, // 用户id
        phone: this.userPhone, // 用户手机号
        payStartTime: this.paymentStatusA, // 付款开始时间 Y-M-D H:I:S
        payEndTime: this.paymentStatusB, // 付款结束时间 Y-M-D H:I:S
        ordernum: this.userOrder, // 订单号
        status: this.selectorValue, // 支付状态:0=已取消,1=待支付,2=已支付,3=已发货,4=待评价,5=已完成，6=售后中,9=已删除
        shouhuoStartTime: this.deliveryStatusA, // 确认收货开始时间
        shouhuoEndTime: this.deliveryStatusB, // 确认收货结束时间
        pageNo: this.page,
        pageSize: this.limit,
      }

      getorderDetail(params).then((res) => {
        if (res.resultStatus == true) {
          // 获取表格数组
          this.tableData = res.resultData.list
          // 获取总数
          this.orderTotal = res.resultData.totalNum
          this.loading = false
        }
        // if (res.code == 200) {
        //   // 获取数据对象
        // //   this.tableData = res.content.list
        // //   this.tableData.forEach((item, index) => {
        // //     for (let i = 0; i < item.list.length; i++) {
        // //       if (item.list[i].is_shouhou == 2) {
        // //         item.status = 11
        // //       }
        // //     }
        // //     ;(item.status =
        // //       item.status == 2
        // //         ? '待发货'
        // //         : item.status == 3
        // //         ? '待收货'
        // //         : item.status == 5
        // //         ? '已完成'
        // //         : item.status == 6
        // //         ? '售后中'
        // //         : item.status == 11
        // //         ? '已售后'
        // //         : ''),
        // //       (item.paytime = this.formatDate(item.paytime)),
        // //       (item.shouhuotime =
        // //         item.shouhuotime != ''
        // //           ? this.formatDate(item.shouhuotime)
        // //           : ''),
        // //       (item.priceStatus =
        // //         item.priceStatus == 'ENTER'
        // //           ? '已获取'
        // //           : item.priceStatus == 'WAIT'
        // //           ? '锁定中'
        // //           : item.priceStatus == 'PAST'
        // //           ? ''
        // //           : '')
        // //   })

        // //   // 总条数
        // //   this.orderTotal = res.content.totalNum
        // } else {
        //   // 退出登陆 清除用户资料

        // }
      })
    },
    // 获取对应订单id后的数据订单详情
    orderDetails(id) {
      let params = {
        order_id: '',
      }
      orderDetail(params).then((res) => {
        if (res.data.code == 200) {
          // 获取对应的对象进行存储
          // this.orderDetailsObj = res.data.content
          // this.orderShow = true
        } else {
          // 退出登陆 清除用户资料
          localStorage.clear()
          // 重设路由
          resetRouter()
        }
      })
    },

    handleSizeChange(val) {
      this.limit = val
      this.loading = true
      this.orderList()
    },
    //  查询当前页
    handleCurrentChange(val) {
      this.page = val
      this.loading = true
      this.orderList()
    },
  },
}
</script>

<style lang="less" scoped>
:focus-visible {
  outline: -webkit-focus-ring-color auto 0px;
}

/deep/ .el-date-editor .el-range-separator {
  width: 30px;
}

/deep/ .el-input__suffix {
  height: 32px !important;
}

/deep/ .el-input__inner {
  padding: 0 0 0 10px;
  height: 30px;
  line-height: 30px;
}

/deep/ .el-date-editor .el-range__icon {
  line-height: 29px;
}

/deep/ .el-date-editor .el-range-separator {
  line-height: 29px;
}

/deep/ .el-date-editor .el-range__close-icon {
  line-height: 29px;
}

.orderview {
  margin-top: 20px;

  .orderview-first {
    background: #fff;
    padding: 24px;
    box-sizing: border-box;

    .orderview-display-left {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;

      .orderview-mergeId {
        display: flex;
        height: 40px;
        align-items: center;
        width: 100%;
        justify-content: space-between;

        .orderview-first-div0 {
          display: flex;
          height: 40px;
          align-items: center;
          margin-right: 10px;

          .orderview-first-div0-title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            margin-right: 10px;
            text-align: left;
          }

          /deep/ .el-input {
            width: 200px;
          }

          /deep/ .el-input__inner {
            height: 32px;
            line-height: 32px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            cursor: pointer;
          }

          /deep/ .el-input__icon {
            line-height: 32px;
          }
        }

        .orderview-first-div0:last-child {
          margin-right: 0;
        }
      }
    }

    .orderview-display-right {
      display: flex;
      height: 40px;
      align-items: center;
      width: 100%;
      margin-top: 6px;
      justify-content: space-between;

      .orderview-display-right-queer {
        display: flex;
        align-items: center;
        height: 40px;

        .orderview-first-div1 {
          display: flex;
          height: 40px;
          align-items: center;

          .orderview-first-title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            width: 84px;
            margin-right: 10px;
          }

          /deep/ .el-date-editor .el-range-separator {
            width: 40px;
            line-height: 30px;
            font-size: 14px;
            display: flex;
            align-items: center;
          }

          /deep/ .el-date-editor .el-range-input {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }

          /deep/ .el-input__inner {
            height: 32px;
            width: 280px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }

          /deep/ .el-date-editor .el-range__icon {
            line-height: 32px;
          }
        }

        .orderview-first-div2 {
          display: flex;
          height: 40px;
          align-items: center;
          margin-left: 64px;

          .orderview-first-title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            width: 84px;
            margin-right: 10px;
          }

          /deep/ .el-date-editor .el-range-separator {
            width: 40px;
            line-height: 30px;
            font-size: 14px;
            display: flex;
            align-items: center;
          }

          /deep/ .el-date-editor .el-range-input {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }

          /deep/ .el-input__inner {
            height: 32px;
            width: 280px;
          }

          /deep/ .el-date-editor .el-range__icon {
            line-height: 30px;
          }
        }
      }

      .orderview-display-right-dextro {
        .orderview-first-div4 {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-left: 30px;

          .orderview-first-right {
            display: flex;

            .orderview-first-right-inquire {
              width: 60px;
              height: 32px;
              background: #29d647;
              border-radius: 5px;
              text-align: center;
              line-height: 32px;
              cursor: pointer;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
            }

            .orderview-first-right-derive {
              width: 88px;
              height: 32px;
              border-radius: 5px;
              border: 1px solid #29d647;
              text-align: center;
              line-height: 32px;
              cursor: pointer;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #29d647;
              margin-left: 20px;
            }
          }
        }
      }
    }
  }

  .orderview-table {
    margin-top: 10px;
    background: #fff;
    padding: 24px;
    box-sizing: border-box;
    cursor: pointer;

    /deep/ .el-table th.el-table__cell > .cell {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333;
    }

    /deep/ .el-table {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #555555;
    }

    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
      width: 10px;
      /*滚动条宽度*/
      height: 10px;
      /*滚动条高度*/
      cursor: pointer;
    }

    /*定义滚动条轨道 内阴影+圆角*/
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
      box-shadow: 0px 1px 3px #ffffff inset;
      /*滚动条的背景区域的内阴影*/
      border-radius: 10px;
      /*滚动条的背景区域的圆角*/
      background-color: #ffffff;
      /*滚动条的背景颜色*/
    }

    /*定义滑块 内阴影+圆角*/
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
      box-shadow: 0px 1px 3px #999999 inset;
      /*滚动条的内阴影*/
      border-radius: 10px;
      /*滚动条的圆角*/
      background-color: #999999;
      /*滚动条的背景颜色*/
    }

    .commodity-div {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e8e8e8;
      padding-bottom: 5px;
      padding-top: 5px;

      .commodity-div-left {
        width: 40px;
        height: 40px;
      }

      .commodity-div-right {
        margin-left: 10px;
        text-align: left;

        .commodity-div-right-title {
          color: black;
          font-size: 14px;
          font-weight: 400;
          word-break: break-all;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .commodity-div-right-status {
          color: black;
          font-size: 14px;
          font-weight: 400;
          height: 20px;
          line-height: 20px;
          margin-top: 5px;
        }

        .commodity-div-right-text {
          margin-top: 5px;
          color: black;
          font-size: 14px;
          font-weight: 400;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .commodity-div:last-child {
      border-bottom: 0px solid;
      padding-bottom: 0px;
    }

    .commodity-div:first-child {
      padding-top: 0px;
    }

    .particulars-div {
      display: flex;
      align-items: center;
      cursor: pointer;

      .particulars-img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }

      .particulars-text {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }

    .profitStatus-div,
    .orderStatus-class {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
  }

  .orderview-paging {
    height: 102px;
    width: 100%;
    background: #ffffff;
    padding-right: 30px;

    /deep/ .el-pagination {
      display: flex;
      justify-content: flex-end;
      padding-top: 20px;
    }

    /deep/ .el-pager li {
      width: 32px;
      height: 32px;
      padding: 0;
      line-height: 32px;
      margin-right: 8px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #d9d9d9;
    }

    /deep/ .el-pager li.active {
      background: #eafbed;
      border-radius: 4px;
      color: #29d647;
    }

    /deep/ .el-pager li:hover {
      color: #29d647;
    }

    /deep/ .el-pagination .btn-prev {
      width: 32px;
      height: 32px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #d9d9d9;
      margin-right: 8px;
    }

    /deep/.el-pagination .btn-next {
      width: 32px;
      height: 32px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #d9d9d9;
      margin-right: 8px;
    }

    /deep/ .el-pagination button:hover {
      color: #29d647;
    }
  }
}
</style>
